import BoletoLicencaRecebivelService from "@/services/BoletoLicencaRecebivelService";

export const boletoLicencaRecebivel = {
  namespaced: true,
  state: {
    boletoLicencaRecebivel: {},
  },
  actions: {
    getBoletoLicencaRecebivel({ commit }, payload) {
      return BoletoLicencaRecebivelService.GetBoletoLicencaRecebivel(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postBoletoLicencaRecebivel({ commit }, payload) {
      return BoletoLicencaRecebivelService.PostBoletoLicencaRecebivel(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putBoletoLicencaRecebivel({ commit }, payload) {
      return BoletoLicencaRecebivelService.PutBoletoLicencaRecebivel(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteBoletoLicencaRecebivel({ commit }, payload) {
      return BoletoLicencaRecebivelService.DeleteBoletoLicencaRecebivel(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getBoletoLicencaRecebivelOData({ commit }, payload) {
      return BoletoLicencaRecebivelService.GetBoletoLicencaRecebivelOData(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default boletoLicencaRecebivel;
